import React from 'react';
import { string } from 'prop-types';
import cx from 'classnames';

import useStyles from 'hooks/useStyles';
import { ArrowIcon } from 'components/Icon';

import styles from './ToTop.scss';

const ToTop = ({ className, text }) => {
  useStyles(styles);

  const scrollToTop = () => {
    window.scrollTo({ top: 0 });
  };

  return (
    <div className={cx(styles.root, className)}>
      <button className={styles.button} type="button" onClick={scrollToTop}>
        <ArrowIcon />
      </button>
      <div className={styles.text}>{text}</div>
    </div>
  );
};

ToTop.propTypes = {
  className: string,
  text: string.isRequired,
};

ToTop.defaultProps = {
  className: '',
};

export default ToTop;
